export default __webpack_public_path__ + "fe60a6057179c202873898bada7d0b5b.webp";